import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { IconButton, Popover } from '@material-ui/core';
import { useRecoilState } from 'recoil';
import { isOnMobileDisplayKnowledgeAtom } from '@/state/atom/panelAtom';
import { isValidHttpUrl } from '@/component/supportIframe/handler/iFrameHandler';
import Utils from '@/common/utils/utils';
import Constant from '@/common/constant/Constant';
import { generateIframeLink } from '@/component/system/handler/ProjectSettingIframeHandler';
import { getLinkDownloadFileFromS3 } from '@/component/common/FileUploaded';

export default function HeaderPublicKnowledge(props) {
    const local = useLocation();
    const currentUrl = `${local.pathname.split('/kb')[0]}/kb`;

    const { subDomain } = useParams();
    const [isLinkElementLoaded, setLinkElementLoaded] = useState(false);
    const [isOnMobileDisplayKnowledge, setIsOnMobileDisplayKnowledge] = useRecoilState(
        isOnMobileDisplayKnowledgeAtom
    );
    const [openSettingMenu, setOpenSettingMenu] = useState(false);
    let { infoSettingPublicKnowledge, publicKnowledgeProjectId, iframeSetting } = props;

    let iframeSrcData = {
        subDomain: subDomain,
        projectId: publicKnowledgeProjectId
    };

    let encodeData = Utils.encodeDataByCrypto(
        iframeSrcData,
        Constant.SECRET_KEY_ENCRYPT_GENERATE_DATA
    );
    const settingIframe = Utils.convertJSONDataToObject(iframeSetting);
    let iframeSrc = `${window.location.origin}${
        Constant.IFRAME_LOGIN_ROUTER
    }?backgroundColor=${encodeURIComponent(settingIframe.backgroundColor)}&info=${encodeData}`;
    let iframeLink = generateIframeLink(iframeSrc, settingIframe, true);

    useEffect(() => {
        if (isValidHttpUrl(infoSettingPublicKnowledge?.styleSheet)) {
            const linkElement = document.createElement('link');
            linkElement.setAttribute('rel', 'stylesheet');
            linkElement.setAttribute('type', 'text/css');
            linkElement.setAttribute('href', infoSettingPublicKnowledge?.styleSheet);
            document.head.appendChild(linkElement);
        } else {
            const linkElement = document.createElement('style');
            linkElement.textContent = infoSettingPublicKnowledge?.styleSheet;
            document.head.appendChild(linkElement);
        }
        setLinkElementLoaded(true);
    }, [infoSettingPublicKnowledge]);

    const getUrlImage = s3Key => {
        let keyFile = `/public/${s3Key}`;
        let link = Utils.getCloudFrontUrlOfFilePublicAll(keyFile);
        if (link) return link;

        let fileUpload = {
            fileUrl: s3Key,
            type: Constant.S3_FILE_TYPE.TICKET_FILE
        };
        link = getLinkDownloadFileFromS3(fileUpload, {}, null, null, false, true);

        return link;
    };
    const handleClose = () => {
        setOpenSettingMenu(false);
    };
    const handleOpen = () => {
        setOpenSettingMenu(true);
    };

    return (
        <>
            {isLinkElementLoaded && (
                <div className="wrap-header-knowledge-pknowledge">
                    {infoSettingPublicKnowledge?.header ? (
                        <div
                            className="header-public-custom"
                            dangerouslySetInnerHTML={{ __html: infoSettingPublicKnowledge?.header }}
                        ></div>
                    ) : (
                        <></>
                    )}
                    <div className="center-header-knowledge-pknowledge">
                        <div className="item-header-knowledge-pknowledge">
                            <button
                                onClick={() =>
                                    setIsOnMobileDisplayKnowledge(!isOnMobileDisplayKnowledge)
                                }
                                className="btn-nav"
                            >
                                <img src="/assets/image/icon-nav.svg" alt="" />
                            </button>

                            <div className="logo-knowledge">
                                {!Utils.isEmptyString(infoSettingPublicKnowledge?.logo) && (
                                    <a href={currentUrl}>
                                        <img
                                            src={getUrlImage(infoSettingPublicKnowledge?.logo)}
                                            className="img-logo-knowledge"
                                            alt="img-logo-knowledge"
                                        />
                                    </a>
                                )}
                            </div>
                            {props?.isPublicAccess && (<div
                                className={
                                    infoSettingPublicKnowledge?.isShowIframe &&
                                    iframeSetting?.public
                                        ? 'right-header-knowledge-with-iframe-public-knowledge'
                                        : 'right-header-knowledge-without-iframe-public-knowledge'
                                }
                            >
                                <Link
                                    to={{ pathname: `/login/${subDomain}` }}
                                    target="_blank"
                                    className="link-login-sdesk"
                                >
                                    <span>SolutionDeskへログイン→</span>
                                    {/* <div className="logo-knowledge">
                                        <img
                                            src="/assets/image/button-login-knowledge.svg"
                                            alt="login"
                                        />
                                    </div> */}
                                </Link>

                                {infoSettingPublicKnowledge?.isShowIframe &&
                                iframeSetting?.public ? (
                                    <Link
                                        to={{
                                            pathname: `${iframeLink}`
                                        }}
                                        target="_blank"
                                        className="link-contact-sdesk"
                                    >
                                        <span>お問い合わせ→</span>
                                    </Link>
                                ) : (
                                    <span></span>
                                )}
                            </div>)}
                        </div>
                        <IconButton className="button-list-url" onClick={handleOpen}>
                            <img src="/assets/image/icon-nav-tabs.svg" alt="" />
                        </IconButton>
                    </div>

                    <div>
                        <Popover
                            className="iframe-drop-list"
                            id={'simple-popover'}
                            open={openSettingMenu}
                            anchorEl={openSettingMenu}
                            onClose={handleClose}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'center'
                            }}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right'
                            }}
                        >
                            <ul>
                                <li
                                    onClick={e => {
                                        window.location.href = `/login/${subDomain}`;
                                    }}
                                >
                                    <span className="navTabs-item">
                                        <img
                                            src="/assets/image/button-login-knowledge-mobile.svg"
                                            alt="login"
                                        />
                                    </span>
                                    <span className="navTabs-text">SolutionDeskへログイン</span>
                                </li>
                                {infoSettingPublicKnowledge?.isShowIframe && iframeSetting?.public && (
                                    <li
                                        onClick={e => {
                                            window.location.href = `${iframeLink}`;
                                        }}
                                    >
                                        <span className="navTabs-item">
                                        <img
                                            src="/assets/image/button-left-arrow.svg"
                                            alt="login"
                                        /></span>
                                        <span className="navTabs-text">お問い合わせ</span>
                                    </li>
                                )}
                            </ul>
                        </Popover>
                    </div>
                </div>
            )}
        </>
    );
}
